import React from 'react';

import StorageReportContainer from '@totem/components/administration/storageReporting/StorageReportContainer';
import {
  StorageReportExtra,
  StorageReportLayout,
} from '@totem/components/administration/storageReporting/StorageReportLayout';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';

const StorageReportPage = () => (
  <ContentLayout>
    <StorageReportContainer>
      <IBCard
        isCovered
        title="Storage Reporting"
        extra={<StorageReportExtra />}
      >
        <StorageReportLayout />
      </IBCard>
    </StorageReportContainer>
  </ContentLayout>
);

export default StorageReportPage;
